import React from 'react';

export const THEMES = [
  'marketplace',
  'yelp',
  // themes from Hermosa
  'blueberry',
  'blueraspberry',
  'citrus',
  'eggplant',
  'grape',
  'grass',
  'kiwi',
  'persimmon',
  'raspberry',
  'sage',
  'tomato',
  'turquoise',
  'vanilla',
] as const;

export type Theme = (typeof THEMES)[number];

export type ThemeContextProps = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  setThemeOverride: (theme: 'vanilla' | null) => void;
};

export const ThemeContext = React.createContext<ThemeContextProps>({
  theme: 'vanilla',
  setTheme: () => {},
  setThemeOverride: () => {},
});

/**
 * Active theme for the app
 * setTheme(value) overrides, setTheme(null) clears.
 * @param children
 * @constructor
 */
export const ThemeProvider: React.FunctionComponent<
  React.PropsWithChildren
> = ({ children }) => {
  const [theme, setTheme] = React.useState<Theme>('vanilla');
  const [themeOverride, setThemeOverride] = React.useState<'vanilla' | null>(
    null
  );
  const currentTheme = themeOverride ?? theme;

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = { theme: currentTheme, setTheme, setThemeOverride };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};
